import React, { useEffect, useState } from "react";
import "../../styles/omr/main.css";
import { getAllOMR } from "../../Services/AllAPIs";
import LoadingSpinner from "../LoadingSpinner";

const Main = () => {
    const [loader, setLoader] = useState(true);
    const [omr, setOmr] = useState([]);
    const [error, setError] = useState(null);

    const getOMRData = () => {
        getAllOMR()
            .then((res) => {
                console.log(res.data); 
                if (Array.isArray(res.data)) {
                    setOmr(res.data); 
                } else {
                    setError("Invalid OMR data format.");
                }
                setLoader(false);  
            })
            .catch((error) => {
                console.log("Error fetching OMR data:", error);  
                setError("An error occurred while fetching OMR data.");
                setLoader(false);
            });
    };

    useEffect(() => {
        getOMRData();
    }, []);

    return (
        <div id="omrMain">
            <div className="mid-container container mt-5 mb-5">
                <div className="row">
                    <div className="omr-ans-key">
                        <h2 className="my-heading text-white m-0">OMR Answer Keys 2024</h2>
                    </div>
                    <div className="col-md-5 mb-2">
                        <div className="image-container">
                            <img src="/assets/images/omr-l.jpg" alt="OMR" />
                        </div>
                    </div>
                    <div className="col-md-6">
                        <div className="content">
                            <a
                                href="https://exams.ccsuforms.in/omrresults/"
                                target="_blank"
                                rel="noreferrer"
                                className="view-omr-answer-btn"
                            >
                                <span>
                                    <i className="fas fa-external-link-alt mr-1" />
                                </span>{" "}
                                View Omr Answer Sheet & Response
                            </a>

                            {loader && <LoadingSpinner />}

                            {error && <div className="error">{error}</div>}

                            <div className="links-container">
                                {omr.length > 0 ? (
                                    omr.map((item, index) => (
                                        <div className="link-item" key={index}>
                                            <img
                                                src="/assets/images/new2.gif"
                                                alt="Loading GIF"
                                                className="gif-image"
                                            />
                                            <a href={`omr/${item.url}`} target="_blank" rel="noopener noreferrer">
                                                {item.title} 
                                            </a>
                                        </div>
                                    ))
                                ) : (
                                    <div className="no-omr-found">No OMR found</div>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Main;
